import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=139e3094&scoped=true"
import script from "./ErrorList.vue?vue&type=script&lang=ts"
export * from "./ErrorList.vue?vue&type=script&lang=ts"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=139e3094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e3094",
  null
  
)

export default component.exports